var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: _vm.titulo } },
        [
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("v-autocomplete", {
                    attrs: {
                      "item-text": "nombre",
                      items: _vm.lista_clientename,
                      label: _vm.formFields.cliente_id_new.label,
                      "item-value": "rut",
                      "prepend-icon": "home_repair_service"
                    },
                    on: {
                      input: function($event) {
                        return _vm.get_flota()
                      }
                    },
                    model: {
                      value: _vm.formFields.cliente_id_new.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cliente_id_new, "value", $$v)
                      },
                      expression: "formFields.cliente_id_new.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      label: _vm.formFields.cliente_id_new.label,
                      "prepend-icon": "home_repair_service",
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.cliente_id_new.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cliente_id_new, "value", $$v)
                      },
                      expression: "formFields.cliente_id_new.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.cod_flota_new.label,
                      required: "",
                      "item-text": "nombre",
                      "item-value": "id",
                      items: _vm.lista_flotaname,
                      "prepend-icon": "integration_instructions",
                      color: "primary"
                    },
                    on: {
                      input: function($event) {
                        return _vm.get_pantente()
                      }
                    },
                    model: {
                      value: _vm.formFields.cod_flota_new.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cod_flota_new, "value", $$v)
                      },
                      expression: "formFields.cod_flota_new.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      label: _vm.formFields.cod_flota_new.label,
                      "prepend-icon": "home_repair_service",
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.cod_flota_new.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.cod_flota_new, "value", $$v)
                      },
                      expression: "formFields.cod_flota_new.value"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm3: "", md3: "" } },
            [
              _vm.accion_modal != "EDITAR"
                ? _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.patente_vehiculo_new.label,
                      items: _vm.lista_patentes,
                      "item-text": "patente_vehiculo",
                      "item-value": "patente_vehiculo",
                      required: "",
                      "prepend-icon": "integration_instructions",
                      color: "primary"
                    },
                    model: {
                      value: _vm.formFields.patente_vehiculo_new.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.patente_vehiculo_new,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.patente_vehiculo_new.value"
                    }
                  })
                : _vm._e(),
              _vm.accion_modal == "EDITAR"
                ? _c("v-text-field", {
                    attrs: {
                      label: _vm.formFields.patente_vehiculo_new.label,
                      "prepend-icon": "home_repair_service",
                      disabled: ""
                    },
                    model: {
                      value: _vm.formFields.patente_vehiculo_new.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.formFields.patente_vehiculo_new,
                          "value",
                          $$v
                        )
                      },
                      expression: "formFields.patente_vehiculo_new.value"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }